module.exports = __webpack_public_path__ + "static/media/desktop.a9f8d327.jpg";